import axios from 'axios';

const http = new (function() {
    let url = (process.env.NODE_ENV === 'development') || location.hostname === "website.localhost" || location.hostname === "127.0.0.1" ? 'http://127.0.0.1:8000/api/' : 'https://cheetah-api.builderall.com/api/';

    this.api = function() {
        return axios.create({
            baseURL: url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        });
    };

    this.authApi = function() {
        var token = localStorage.getItem('login-user-token')
            ? localStorage.getItem('login-user-token')
            : '';

        return axios.create({
            baseURL: url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${token}`
            }
        });
    };
})();

export default http;
